import { render, staticRenderFns } from "./CompanyRole.vue?vue&type=template&id=17c9345c"
import script from "./CompanyRole.vue?vue&type=script&lang=js"
export * from "./CompanyRole.vue?vue&type=script&lang=js"
import style0 from "./CompanyRole.vue?vue&type=style&index=0&id=17c9345c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports